import { baseService } from '@repo/services';

export interface AiCallAgent {
  agent_uuid: string;
  name: string;
  active: boolean;
}

export interface GetAiCallAgentsResponse {
  success: boolean;
  data: AiCallAgent[];
}

// Endpoint name is automation-specific to avoid colliding with the apps/crm agent-management
// service (both inject a query onto the shared @repo/services baseService); packages can't import
// the apps/crm one, so the automation node keeps its own lightweight list query under a unique key.
const aiCallAgentsService = baseService.injectEndpoints({
  endpoints: (build) => ({
    getAutomationAiCallAgents: build.query<GetAiCallAgentsResponse, void>({
      query: () => ({ method: 'GET', url: '/v1/ai_call_agents' }),
    }),
  }),
});

export const { useGetAutomationAiCallAgentsQuery } = aiCallAgentsService;
export default aiCallAgentsService;
